/*
 * @Author: Teemo Ding
 * @Date: 2022-03-11 09:48:54
 * @LastEditTime: 2022-07-08 16:10:16
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Components/SendTestModal/index.tsx
 */
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import { unique } from '@/src/tools/helper';
import {
  getI18nFromGeneral,
  replaceI18nVariables,
  getAreaCodeUuid,
} from '@/src/tools/tools';
import React, { Fragment, useState } from 'react';
import { Input, ModalFooter, NumberInput } from 'src/components/Antd';
import { EnumMode } from 'src/components/Antd/NumberInput/NumberInput';
import { cloneDeep, get } from 'lodash';
import { AreaCodeInfo } from 'src/components/AreaCodeInfo';
import Tags from 'src/components/Tags/Tags';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { CommunicationChannelType } from 'src/types/common/communication';
import css from './css.module.less';

//const Option = Select.Option;

function SendTestModal({ onOkPress, onCancel, channelType, areaCodesOptions }) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [email, setEmail] = useState('');
  const [emailList, setEmailList] = useState([]);
  const [areaCodeInfo, setAreaCodeInfo] = useState({ uuid: null });
  const [mobile, setMobile] = useState();
  const [mobileList, setMobileList] = useState([]);
  const regBreak = new RegExp(/[,｜\s｜，|,]+/g);
  const tagClose = (e, index) => {
    const mobileListCopy = cloneDeep(mobileList);
    mobileListCopy.splice(index, 1);
    setMobileList(mobileListCopy);
    const emailListCopy = cloneDeep(emailList);
    emailListCopy.splice(index, 1);
    setEmailList(emailListCopy);
  };
  const handleEmailChange = (value) => {
    if (regBreak.test(value)) {
      handleEmailBreak();
    } else {
      setEmail(value);
    }
  };

  const handleEmailBreak = () => {
    if (email) {
      const emailListCopy = cloneDeep(emailList);

      emailListCopy.push(email);
      setEmailList(unique(emailListCopy));
      setEmail('');
    }
  };

  const handleAreaCodeChange = (data) => {
    setAreaCodeInfo(data);
  };
  const handleMobileAdd = () => {
    if (getAreaCodeUuid(areaCodeInfo) && mobile) {
      const mobileListCopy = cloneDeep(mobileList);
      const areaCodeInText = get(
        areaCodesOptions.find((i) => i.uuid === getAreaCodeUuid(areaCodeInfo)),
        'areaCode',
      );
      mobileListCopy.push(`+${areaCodeInText} ${mobile}`);
      setMobileList(unique(mobileListCopy));
      setAreaCodeInfo({ uuid: null });
      setMobile(undefined);
    }
  };

  return (
    <Fragment>
      <div className={css.sendTestModal}>
        {channelType === CommunicationChannelType.Email ? (
          <ItemWrapper
            title={getI18n('salesChannelCommunication.index.sendToEmail')}
            bottomTitle={getI18n(
              'salesChannelCommunication.index.sendToEmailBottomTitle',
            )}>
            <Input
              size='large'
              onChange={handleEmailChange}
              value={email}
              onPressEnter={handleEmailBreak}
            />
            <Tags onClose={tagClose} data={emailList} />
          </ItemWrapper>
        ) : (
          <ItemWrapper
            title={replaceI18nVariables(
              getI18n('salesChannelCommunication.index.sendTotextnumber'),
              channelType === CommunicationChannelType.WhatsApp
                ? getI18n('salesChannelCommunication.index.whatsApp')
                : getI18n('general.mobile'),
            )}
            bottomTitle={getI18n(
              'salesChannelCommunication.index.sendTotextnumberBottomTitle',
            )}>
            <div className={css.mobileNumber}>
              <AreaCodeInfo
                value={areaCodeInfo}
                onChange={handleAreaCodeChange}
                options={areaCodesOptions}
              />
              {/* <Select
                size='large'
                formProps={{ className: css.areaCode }}
                value={areaCode}
                onChange={handleAreaCodeChange}>
                {(areaCodesOptions || []).map((i) => {
                  const { label, value, uuid } = i;
                  return (
                    <Option value={value} key={uuid}>
                      {label}
                    </Option>
                  );
                })}
              </Select> */}
              <NumberInput
                size='large'
                mode={EnumMode.int}
                onChange={setMobile}
                value={mobile}
                onPressEnter={handleEmailChange}
              />
              <span onClick={handleMobileAdd} className={css.add}>
                {getI18n('general.linkModule.Modal.add')}
              </span>
            </div>
            <Tags onClose={tagClose} data={mobileList} />
          </ItemWrapper>
        )}
      </div>
      <ModalFooter
        okText={getI18nFromGeneral('general.antd.Modal.ModalFooter.confirm')}
        cancelText={getI18nFromGeneral('general.commonHeader.discard_text')}
        onOk={() =>
          onOkPress(
            channelType === CommunicationChannelType.Email
              ? emailList
              : mobileList,
          )
        }
        onCancel={onCancel}
      />
    </Fragment>
  );
}

export default SendTestModal;
